import React from 'react';
import { ArrowDown, Clock, Video } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/304e54fc525d214e_image.png)' }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628]/92 via-[#0f2440]/88 to-[#0a1628]/92"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-6 animate-fade-in">
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-tight">
            {t('hero.welcome')}
            <span className="block mt-2 bg-gradient-to-r from-sky-200 to-blue-100 bg-clip-text text-transparent">
              {t('hero.churchName')}
            </span>
          </h1>

          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 pt-2">
            <div className="flex items-center gap-2 text-sky-200">
              <Clock className="w-5 h-5" />
              <span className="text-base font-medium">{t('hero.serviceTime')}</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-white/40"></div>
            <div className="flex items-center gap-2 text-sky-200">
              <Video className="w-5 h-5" />
              <span className="text-base font-medium">{t('hero.onsite')}</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <button
              onClick={() => scrollToSection('visit')}
              data-testid="hero-cta-gottesdienst"
              className="px-8 py-4 bg-white text-[#0f2440] rounded-lg font-semibold hover:bg-sky-50 transition-all hover:scale-105 hover:shadow-2xl flex items-center gap-2"
            >
              {t('hero.ctaVisit')}
            </button>
            <button
              onClick={() => scrollToSection('welcome')}
              data-testid="hero-cta-kontakt"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-semibold hover:bg-white/20 transition-all hover:scale-105"
            >
              {t('hero.ctaContact')}
            </button>
          </div>

          <div className="grid grid-cols-3 gap-8 mt-10 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-5xl font-bold text-white mb-1">17</div>
              <div className="text-white/70 text-xs md:text-sm">{t('hero.years')}</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-5xl font-bold text-white mb-1">8</div>
              <div className="text-white/70 text-xs md:text-sm">{t('hero.nations')}</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-5xl font-bold text-white mb-1">35</div>
              <div className="text-white/70 text-xs md:text-sm">{t('hero.members')}</div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollToSection('welcome')}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer"
        aria-label="Scroll down"
      >
        <ArrowDown className="w-8 h-8 text-white/70" />
      </button>

      <style>{`
        @keyframes fade-in { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        .animate-fade-in { animation: fade-in 1s ease-out; }
      `}</style>
    </section>
  );
};

export default Hero;
